import React from 'react';

const Updates = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        When we update this policy:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Users will be notified of significant changes</li>
        <li>Updates will be clearly dated and documented</li>
        <li>Previous versions will remain accessible</li>
        <li>Changes will not be retroactive without consent</li>
      </ul>
    </div>
  );
};

export default Updates;